var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23,
    stroke: "#fff",
    strokeWidth: 2.789
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.068 27.05L20.254 34v-.005H23l-4.412-7.119c1.392-.292 2.44-.885 3.138-1.78.698-.894 1.047-1.926 1.047-3.099 0-.958-.226-1.811-.679-2.56-.458-.748-1.142-1.342-2.057-1.78-.916-.438-2.039-.657-3.365-.657H11v17h2.293v-6.95h2.775zm.604-1.78h-3.379v-6.44h3.379c1.26 0 2.199.279 2.813.83.613.553.92 1.352.92 2.342s-.312 1.784-.935 2.378c-.623.593-1.552.89-2.798.89zm24.19-4.268c-.76-1.282-1.85-2.272-3.27-2.961v-.005c-1.42-.69-3.104-1.036-5.045-1.036H27v17h5.547c1.941 0 3.624-.338 5.044-1.013 1.42-.676 2.51-1.648 3.271-2.926.76-1.273 1.138-2.783 1.138-4.522 0-1.739-.383-3.254-1.138-4.537zm-1.243 4.541c0 2.095-.603 3.724-1.813 4.888-1.21 1.164-2.964 1.744-5.264 1.744h-3.218V18.812h3.218c2.28 0 4.03.593 5.25 1.78 1.22 1.186 1.827 2.857 1.827 4.951z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.b99adea9bac470d744ca091212c5442b.svg";
export { ForwardRef as ReactComponent };